import { gql } from '@apollo/client'

export const ME_QUERY = gql`
  query me {
    me {
      id
      jurnodesAllowed
      feedbacksEnabled
      receivedEmailEnabled
      caseEmailsEnabled
      firstname
      lastname
      birthDate
      email
      street
      houseNumber
      place
      postalCode
      mobileNumber
      phoneNumber
      name
      aiAvailable
      aiAgents {
        id
        name
        url
        chatEnabled
        welcomeMessage
        icon {
          url
        }
      }
      createdAt
      updatedAt
      role
      pools {
        id
        slug
        name
        menuTitle
        columnDefinitions
        maxSelfAssignSelection
        icon {
          url
        }
      }
      visibleEmployeeList
      avatar {
        url
      }
      portalEmail
      portalPhoneNumber
      portalMobileNumber
      allowJobPdfDownload
      away
      awayMessage
      employeeHohner
      hasCallbacksEnabled
      refundAllowed
      payoutsVisible
      reportingEnabled
      callViaVoip
      closingInfoEmailEnabled
      firstcallInfoEmailEnabled
      signature
      schedulingRole
      twoFactorAuthRequired
      twoFactorAuthSetupAt
      otpRequiredForLogin
      languages
      lockedAt
    }
  }
`
